import type { ColumnDef } from "@tanstack/react-table";
import { capitalize, highlightText } from "@repo/utils";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import type { CashLocationMutationCategory } from "~/providers/cash-location-provider";
import { SettingsHeader } from "~/components/layout/settings-header";
import { DataTable } from "~/components/miscellaneous/data-table";
import { DataTableColumnHeader } from "~/components/miscellaneous/data-table-column-header";
import { useCashLocation } from "~/hooks/use-cash-location";

export const Route = createFileRoute(
  "/_main/settings/_layout/mutation-categories/",
)({
  component: MutationCategories,
});

function MutationCategories() {
  const { t } = useTranslation("common");
  const { cashLocationMutationCategories } = useCashLocation();
  const columns: ColumnDef<CashLocationMutationCategory>[] = [
    {
      id: t("name"),
      accessorKey: "name",
      filterFn: "includesString",
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("name")} />
      ),
      cell: ({ row: { original: productcategory }, table }) => {
        const globalFilter = table.getState().globalFilter as string;

        return (
          <p
            dangerouslySetInnerHTML={{
              __html: highlightText(productcategory.name, globalFilter) ?? "",
            }}
          ></p>
        );
      },
    },
  ];

  return (
    <>
      <SettingsHeader
        title={t("product_categories")}
        buttonLabel={capitalize(t("ProductCategory.new_product_category"))}
        buttonAction={async () => {
          await openProductCategoryDialog();
        }}
      />

      <DataTable
        defaultSorting={[{ id: t("ProductCategory.position"), desc: false }]}
        columns={columns}
        data={cashLocationMutationCategories}
        onSelect={openProductCategoryDialog}
      />
    </>
  );
}
